import React from "react";
import { Box, Card } from "@curves/ui-base";
import { parseDate } from "@util/moment";
import { parseCardExpiry } from "@util/utils";
import { Grid } from "@mui/material";
import { ReadTextField } from "@icoach/components";
import { useSmartFitnessContext } from "@icoach/smartFitnessBand/components/SmartFitnessContext";
import clsx from "clsx";

const SmartFitnessBandContractDetailOrderMainPanel = () => {
	const { contractApplySourceData } = useSmartFitnessContext();
	const { memberName, cellPhone, memberNo, birthday, payment, invoice, employeeName, mail } = contractApplySourceData;
	const { creditCardNo, cardExpiryDate, cardName, cardRelation, creditCardTypeText } = payment;
	const { carrierTypeText, issuingTypeText } = invoice;

	return (
		<Box>
			<Card className="order-info-card mb-4">
				{/* <-- 訂閱人資訊 --> */}
				<Card.CardHeader title="訂閱人資訊" className={clsx("px-4", "bg-light-active")} />
				<Card.CardContent className="p-4">
					<Grid spacing={3} container>
						<Grid xs={4} item>
							<ReadTextField label="會員姓名">{memberName}</ReadTextField>
						</Grid>
						<Grid xs={4} item>
							<ReadTextField label="手機">{cellPhone}</ReadTextField>
						</Grid>
						<Grid xs={4} item>
							<ReadTextField label="會員編號">{memberNo}</ReadTextField>
						</Grid>
						<Grid xs={4} item>
							<ReadTextField label="生日">{parseDate(birthday, "YYYY/MM/DD")}</ReadTextField>
						</Grid>
					</Grid>
				</Card.CardContent>
				{/* <-- 付款資訊 --> */}
				<Card.CardHeader title="付款資訊" className={clsx("px-4", "bg-light-active")} />
				<Card.CardContent className="p-4">
					<Grid spacing={3} container>
						<Grid xs={4} item>
							<ReadTextField label="信用卡資訊">{creditCardNo}</ReadTextField>
						</Grid>
						<Grid xs={4} item>
							<ReadTextField label="有效期限">{parseCardExpiry(cardExpiryDate)}</ReadTextField>
						</Grid>
						<Grid xs={4} item>
							<ReadTextField label="持卡人姓名">{cardName}</ReadTextField>
						</Grid>
						<Grid xs={4} item>
							<ReadTextField label="卡片關係人">{cardRelation}</ReadTextField>
						</Grid>
						<Grid xs={4} item>
							<ReadTextField label="卡別">{creditCardTypeText}</ReadTextField>
						</Grid>
					</Grid>
				</Card.CardContent>
				{/* <-- 發票資訊 --> */}
				<Card.CardHeader title="發票資訊" className={clsx("px-4", "bg-light-active")} />
				<Card.CardContent className="p-4">
					<Grid spacing={3} container>
						<Grid xs={4} item>
							<ReadTextField label="載具類型">{carrierTypeText}</ReadTextField>
						</Grid>
						<Grid xs={4} item>
							<ReadTextField label="發票類型">{issuingTypeText}</ReadTextField>
						</Grid>
						<Grid xs={4} item>
							<ReadTextField label="寄送載具信箱">{mail}</ReadTextField>
						</Grid>
					</Grid>
				</Card.CardContent>
				{/* <-- 店舖教練資訊 --> */}
				<Card.CardHeader title="店舖教練資訊" className={clsx("px-4", "bg-light-active")} />
				<Card.CardContent className="p-4">
					<Grid spacing={3} container>
						<Grid xs={4} item>
							<ReadTextField label="擔當">{employeeName}</ReadTextField>
						</Grid>
					</Grid>
				</Card.CardContent>
			</Card>
		</Box>
	);
};

export default SmartFitnessBandContractDetailOrderMainPanel;
